import type { Access, CoachCheckContext, ProductId, OGContextId, OGPayload, SectionLabel } from '../contracts';
export const sectionOGIds: Record<SectionLabel, OGContextId> = {
  Home: 'home', Coaches: 'coaches', Rosters: 'rosters', NIL: 'nil',
  Recruiting: 'recruiting', PXI: 'pxi', Saved: 'saved', Alerts: 'alerts',
  Reports: 'reports', Account: 'account', Subscription: 'subscription', Help: 'help'
};
export const productOGIds: Record<ProductId, OGContextId> = {
  coaches: 'coaches', rosters: 'rosters', nil: 'nil', portal: 'recruiting',
  scheme: 'recruiting', pxi: 'pxi'
};
export function accessFor(context: CoachCheckContext, product: ProductId | 'og'): Access {
  if (!context.userContext.authenticated) return 'gated';
  return context.subscriptionContext.entitlements[product] ?? 'disabled';
}
export function contextKey(context: CoachCheckContext): string {
  const p = context.programContext;
  return [p.id, p.sport, p.season, context.athleteContext?.id ?? 'none'].join(':');
}
export function ogContext(context: CoachCheckContext, currentProduct: OGContextId, result?: { id: string }): OGPayload {
  return { program_id: context.programContext.id, coach_id: context.coachContext?.id ?? null, sport: context.programContext.sport, season: context.programContext.season, position: context.athleteContext?.position ?? null, current_product: currentProduct, current_intelligence_result: result?.id ?? null };
}
export * from './validation.ts';
export * from './rc1.ts';
